import React from 'react'
import SocialNetworkForm from 'views/socialnetwork/SocialNetworkForm'
import { toast, Notification } from 'components/ui'
import { useNavigate } from 'react-router-dom'
import { apiCreateSocialNetwork } from 'services/SocialNetworkService'
import { useTranslation } from 'react-i18next';
import { getSocialNetworkList } from '../SocialNetworkList/store/dataSlice'
import {
	useDispatch,
	useSelector 
} from 'react-redux';
import { setDialog } from '../SocialNetworkForm/store/dataSlice'

const SocialNetworkNew = () => {
	const selectedLanguage = useSelector((state) => state.selectLang.data.selectedLanguage);
	const multiLang = useSelector((state) => state.selectLang.data.multiLang);

	const dispatch = useDispatch();
	const navigate = useNavigate()
	const { t } = useTranslation();
	const tableData = useSelector((state) => state.socialnetworksList.data.tableData)

	const addProduct = async (data) => {
		const response = await apiCreateSocialNetwork(data)
		return response
	}

	const handleFormSubmit = async (values, setSubmitting) => {
		setSubmitting(true)
		const updatedValues = {
			...values,
			webMultiLang: multiLang,
			languageId: selectedLanguage,
		};
		const success = await addProduct(updatedValues)
		setSubmitting(false)
		if (success) {
			dispatch(getSocialNetworkList(tableData))
			toast.push(
				<Notification className="mr-2 mb-2" type="success" duration={1000}>
					{t('toast.addSuccess')}
				</Notification>
			)
			navigate('/cms/SocialNetwork')
		}
		
	}

	const handleDiscard = () => {
		dispatch(setDialog(true));
	}

	return (
		<>
			<h3 className="mb-5">{t('add-edit.addsocialnetwork')}</h3>
			<SocialNetworkForm 
				type="new"
				onFormSubmit={handleFormSubmit}
				onDiscard={handleDiscard}
			/>
		</>
	)
}

export default SocialNetworkNew